<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="fund_citation_tooltip_name" :name="fund_citation_tooltip_name" :description="fund_citation_tooltip_description" :editable="editable"></tool-tip>

    <div v-if="!isPartnerAccount">
    <fund-citation-modal :is-read-only="isReadOnly || !((!isMonetaryOrder && !isNotApplicableEntryAdded) || isMonetaryOrder)" :id="0" :isNew="true">
      <template v-slot:modal-link> ADD</template>
    </fund-citation-modal>
    <finance-system-modal :is-read-only="isReadOnly">
      <template  v-slot:modal-link> SET FINANCE SYSTEM </template>
    </finance-system-modal>
    <base-button v-if='!this.isMonetaryOrder'
      size="sm"
      :disabled="isNotApplicableEntryAdded || isReadOnly"
      :class="!isNotApplicableEntryAdded ? 'not_applicable' : ''"
      class="btn_extra_small btn_info white"
      @click.native="addNotApplicableEntry"
    >
      FUND CITATION NOT APPLICABLE
    </base-button>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <el-table :data="fundCitations" role="table"
        aria-label="Fund Citation Table">
          <el-table-column v-if="!isPartnerAccount" :min-width="30" align="left" label="Actions">
            <div slot-scope="props" class="table-actions">
              <el-tooltip
                content="Delete Citation"
                :open-delay="300"
                effect="light"
                placement="top"
              >
                <fund-citation-delete
                  :is-read-only="isReadOnly || (!isMonetaryOrder && isNotApplicableEntryAdded)"
                  :isIcon="true"
                  v-on:deleteErrorOccurred="deleteErrorOccurred"
                  :id="props.row.fundCitationId"
                >
                  <template v-slot:modal-link>
                    <i class="tim-icons icon-simple-remove"></i>
                  </template>
                </fund-citation-delete>
              </el-tooltip>
              <el-tooltip
                content="Edit Citation"
                :open-delay="300"
                effect="light"
                placement="top"
              >
                <fund-citation-modal
                  :is-read-only="isReadOnly"
                  :isIcon="true"
                  :id="props.row.fundCitationId"
                >
                  <template v-slot:modal-link>
                    <i class="tim-icons icon-pencil"></i>
                  </template>
                </fund-citation-modal>
              </el-tooltip>
            </div>
          </el-table-column>

          <el-table-column
            v-for="column in tableColumns"
            sortable
            :key="column.label"
            :min-width="column.minWidth"
            :formatter="column.formatter"
            :prop="column.prop"
            :label="column.label"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn } from "element-ui";
import { BaseSwitch, BaseButton, Modal } from "@/components";
import FinanceSystemModal from "@/components/App/order/invoice/fundcitation/FinanceSystemModal.vue";
import FundCitationModal from "@/components/App/order/invoice/fundcitation/FundCitationModal.vue";
import FundCitationDelete from "@/components/App/order/invoice/fundcitation/FundCitationDelete.vue";
import swal from "sweetalert2";
import  toolTip  from "../../../Tooltip";

export default {
  name: "fund-citation",
  props: ["isReadOnly"],
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseSwitch,
    BaseButton,
    Modal,
    FinanceSystemModal,
    FundCitationModal,
    FundCitationDelete,
    toolTip
  },

  data() {
    return {
      tableColumns: [
        {
          prop: "name",
          label: "Fund Citation",
          minWidth: 70,
          scope: "col"
        },
        {
          prop: "abbreviation",
          label: "Abbreviation",
          minWidth: 50,
          scope: "col"
        },
        {
          prop: "amountInMoneyFormat",
          label: "Total Cost Per Fund Citation",
          minWidth: 70,
          scope: "col"
        },
       
      ],
      fund_citation_tooltip_description: '',
        fund_citation_tooltip_name: ''
    };
  },
  async mounted() {
   await this.getAllTooltips()
   this.loadToolTips()
 },
  computed: {
    ...mapGetters({
      fundCitation: "fundCitation/fundCitation",
      fundCitations: "fundCitation/fundCitations",
      preOrder: "preOrderDetail/preOrder",
      isMonetaryOrder: "preOrderDetail/isMonetaryOrder",
      isPartnerAccount: "authentication/isPartnerAccount",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
    isNotApplicableEntryAdded() {
      let existingNotApplicableEntry = this.fundCitations.find(
        (fundCitation) => fundCitation.abbreviation === "NA"
      );

      return !!existingNotApplicableEntry;
    },
  },
  methods: {
    ...mapActions({
      getFundCitations: "fundCitation/getFundCitations",
      getFundCitationStatus: "fundCitation/getFundCitationStatus",
      saveFundCitation: "fundCitation/saveFundCitation",
      getLineItemInvoiceStatus: "lineItemInvoice/getLineItemInvoiceStatus",
      getReplacementItemInvoiceStatus: "replacementItemInvoice/getReplacementItemInvoiceStatus",
      getAllTooltips: "tooltip/getToolTips"
    }),
    loadToolTips(){
    const fundToolTip = this.toolTips.find(e => e.name === "FundCitationModule")
    if(fundToolTip && fundToolTip.status){
      this.fund_citation_tooltip_description = fundToolTip.description ? fundToolTip.description :  null
      this.fund_citation_tooltip_name = fundToolTip.name ? fundToolTip.name :  null

    }
    return },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
    deleteErrorOccurred(error) {
      new swal({
        title: "Cannot Delete Fund Citation",
        text: `Fund Citation is active in line item.`,
        icon: "error",
        confirmButtonColor: "#10b45a",
        confirmButtonText: `Ok`,
      });
    },
    loaded() {
      this.getFundCitations(this.$route.params.id);
      this.getFundCitationStatus(this.$route.params.id);
    },
    addNotApplicableEntry() {
      this.fundCitation.name = "Not Applicable";
      this.fundCitation.abbreviation = "NA";

      let ctx = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          ctx.saveFundCitation(ctx.$route.params.id).then((response) => {
            ctx.getFundCitations(ctx.$route.params.id);
            ctx.getFundCitationStatus(ctx.$route.params.id);
            ctx.getLineItemInvoiceStatus(ctx.$route.params.id);
            ctx.getReplacementItemInvoiceStatus(ctx.$route.params.id);
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.not_applicable {
  background-color: #f0ad4e !important;
  border: #f0ad4e !important;
  background-image: none !important;
}
</style>
